import { css } from '@/styled-system/css';
import { styled } from '@/styled-system/jsx';

import Bone from '../../../../Bone';

export const layoutImageContainerStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  position: 'relative',
  flex: 1,
  minHeight: '257px',
  border: '1px solid {colors.border.subtle}',
  borderRadius: '100',
  padding: '100',
});

export const StyledLoadingImage = styled(Bone, {
  base: {
    borderRadius: '100',
    position: 'absolute',
    width: '100% !important',
    height: '100% !important',
  },
});
